"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Colors = require("../00_environment/Colors");

var _Fonts = require("../00_environment/Fonts");

var _Icon = _interopRequireDefault(require("../01_atoms/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SelectedPassengers = function SelectedPassengers(_ref) {
  var translatorForNamespace = _ref.translatorForNamespace,
      _ref$passengers = _ref.passengers,
      passengers = _ref$passengers === void 0 ? [] : _ref$passengers;
  var t = translatorForNamespace('SelectedPassengers');
  passengers.sort(function (a, b) {
    return a.firstName > b.firstName ? 1 : -1;
  });
  var title = t('No passenger selected');

  if (passengers.length > 0) {
    title = passengers.map(function (p) {
      return p.firstName;
    }).join(', ');

    if (title.includes(',')) {
      var n = title.lastIndexOf(',');
      title = "".concat(title.substr(0, n), " ").concat(t('and')).concat(title.substr(n + 1));
    }
  }

  var style = (0, _Fonts.withWidgetTitleFont)({
    fontSize: '1rem',
    display: 'inline-flex',
    alignItems: 'center'
  });

  if (passengers.length === 0) {
    style = Object.assign(style, {
      color: _Colors.discreetTextColor
    });
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'left',
      display: 'inline-block',
      width: 30
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "user",
    style: {}
  })), ' ', title);
};

var _default = SelectedPassengers;
exports["default"] = _default;